<template>
  <div class="mall-box">
    <div class="info-box">
      <div class="info-left-box">
        <div class="left-img-box">
          <div class="img-box">
            <img v-if="coinInfo.image" :src="coinInfo.image" alt="mall-item.png" />
            <p class="p1">{{ coinInfo.title }}</p>
          </div>
        </div>
        <div class="info-bottom-box">
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t('mall.assetTime') }}</p>
              <p class="p2">
                {{ coinInfo.summary.serviceInfo.debutStartTime }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t('mall.assetPrice') }}</p>
              <p class="p2">{{ coinInfo.summary.valueInfo.firstValue }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t('mall.issuanceTotal') }}</p>
              <p class="p2">{{ coinInfo.summary.chainInfo.publishAmount }}</p>
            </div>
          </div>
          <div class="border" />
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t('mall.outstandingUnits') }}</p>
              <p class="p2">{{ coinInfo.summary.chainInfo.tradeAmount }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t('mall.detail.decimal') }}</p>
              <p class="p2">{{ coinInfo.summary.chainInfo.decimal }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="info-right-box">
        <p class="title">{{ $t('common.more') }}</p>
        <div class="info-title-box">
          <div class="info-title">
            <p class="p1">{{ $t('common.website') }}</p>
            <div
              style="cursor: pointer"
              class="p3 c-flex-align-center"
              @click="openUrl(coinInfo.summary.serviceInfo.mallUrl)"
            >
              {{ coinInfo.summary.serviceInfo.mallUrl }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <!-- <div class="info-title">
            <p class="p1">白皮书</p>
            <div class="p3 c-flex-align-center">
              {{ coinInfo.contractAddress}}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div> -->
          <div class="info-title">
            <p class="p1">{{ $t('mall.detail.contract') }}</p>
            <div class="p3 c-flex-align-center">
              {{ coinInfo.summary.chainInfo.contract }}
              <!-- <i class="el-icon-arrow-right"></i> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <div class="detail-box">
        <div v-html="coinInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    coinType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  data() {
    return {
      coinInfo: {
        summary: {
          valueInfo: {
            firstValue: "",
            totalValue: "",
          },
          chainInfo: {
            contract: "",
            publishAmount: "",
            tradeAmount: "",
            decimal: "",
          },
          serviceInfo: {
            mallUrl: "",
            debutStartTime: "",
          },
        },
      },
    };
  },
  created() {
    this.getSymbolBy();
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    // 获取币种信息
    getSymbolBy() {
      this.$axios
        .post("/cms/getList", {
          page: 1,
          rows: 1,
          cateCode: this.coinType.split('/')[0], // RWA/DIMD/GCT/TOP100
        })
        .then((res) => {
          if (
            res.data.code === this.errorCode.ok &&
            res.data.data.rows &&
            res.data.data.rows.length > 0
          ) {
            this.coinInfo = res.data.data.rows[0];
            const strVal = res.data.data.rows[0].summary;
            this.coinInfo.summary = JSON.parse(strVal);
            console.log(this.coinInfo);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: #f5f6f7;
  .back-box {
    gap: 28px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 120px 260px 60px 260px;
    img {
      width: 44px;
      height: 44px;
    }
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
  }
  .info-box {
    gap: 12px;
    display: flex;
    .info-left-box {
      padding: 20px;
      flex: 1;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .left-img-box {
        display: flex;
        padding-bottom: 20px;
        justify-content: space-between;
        border-bottom: 1px solid #e2e3e3;
        .img-box {
          gap: 20px;
          display: flex;
          align-items: center;
          img {
            width: 34px;
            height: 34px;
          }
          .title {
            gap: 20px;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 24px;
              color: #333333;
            }
            .p2 {
              width: 72px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              background: #eaebed;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .btn-box {
          gap: 12px;
          display: flex;
          align-items: center;
          .btn1 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #4063ff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #4063ff;
          }
          .btn2 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            background: #4063ff;
            border-radius: 8px 8px 8px 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
          }
        }
      }
      .info-bottom-box {
        display: flex;
        margin-top: 20px;
        .border {
          margin: 0 20px;
          border-right: 1px solid #e2e3e3;
        }
        .info-title-box {
          flex: 1;
          gap: 12px;
          display: flex;
          flex-direction: column;
          .info-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
            }
            .p2 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 12px;
              color: #333333;
            }
          }
        }
      }
    }
    .info-right-box {
      padding: 20px;
      width: 410px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e2e3e3;
      }
      .info-title-box {
        flex: 1;
        gap: 12px;
        display: flex;
        flex-direction: column;
        .info-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .p1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
          .p2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 12px;
            color: #333333;
          }
          .p3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 12px;
            color: #333333;
            display: flex;
            gap: 12px;
          }
          .btn {
            width: 44px;
            line-height: 28px;
            text-align: center;
            height: 28px;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }
  }
  .tab-box {
    overflow: hidden;
    background: #ffffff;
    margin: 10px 0;
    border-radius: 12px 12px 12px 12px;
    .tab {
      display: flex;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .sel {
        font-weight: 800;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 2px solid #4063ff;
      }
    }
    .detail-box {
      padding: 20px;
      /deep/ img {
        object-fit: cover;
        width: 100%;
      }
      .file-box {
        height: 52px;
        padding: 0 20px;
        background: #f4f5f6;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          gap: 32px;
          display: flex;
          img {
            width: 28px;
            height: 32px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
          }
        }
        .btn-box {
          gap: 20px;
          display: flex;
          .btn1 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
          .btn2 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #4b6dfe;
          }
        }
      }
    }
  }
}
</style>
